module.exports = __webpack_public_path__ + "img/20190527162329QQ截图20190524163041.2a10ab8f.png";